import { Tag, TagLabel, TagLeftIcon } from "@chakra-ui/react";
import React from "react";
import { RiCircleFill } from "react-icons/ri";

type Props = {
  isConnected: boolean;
};
export const ConnectionTag: React.FC<Props> = ({ isConnected }) => {
  return (
    <Tag variant="outline" colorScheme="gray">
      {isConnected ? <TagLeftIcon as={RiCircleFill} color="green.500" /> : null}
      <TagLabel>{isConnected ? "Connected" : "Not connected"}</TagLabel>
    </Tag>
  );
};
